import { __awaiter, __generator, __values } from "tslib";
import { createContext } from './query-job';
var QueryJobPaginate = /** @class */ (function () {
    function QueryJobPaginate(node, parent) {
        this.node = node;
        this.parent = parent;
        this.context = createContext(node);
    }
    QueryJobPaginate.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, offset, limit, _b, _c, pointers;
            var e_1, _d;
            return __generator(this, function (_e) {
                _a = this.node, offset = _a.offset, limit = _a.limit;
                try {
                    for (_b = __values(this.context.inputs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        pointers = _c.value;
                        output.push(pointers.slice(offset, !limit || isNaN(limit) ? undefined : offset + limit));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    return QueryJobPaginate;
}());
export { QueryJobPaginate };
export default QueryJobPaginate;
//# sourceMappingURL=query-job-paginate.js.map